export default __webpack_public_path__ + "static/media/reel-icon.a14434b8.svg";